import { PModel, PropertyPath } from '../../engine.js';
import { EngineNotificationsService } from './EngineNotificationsService.js';
import { AutoCorrectPropertyEvent } from './AutoCorrectModelEvents.js';

export class AutoCorrectModelPublisher {
  constructor(private notifications: EngineNotificationsService) {
  }
  propertyAutoCorrected<T>(target: PModel, propertyPath: PropertyPath, fromValue: T, toValue: T) {
    this.notifications.notify('AutoCorrectProperty', new AutoCorrectPropertyEvent(target, propertyPath, fromValue, toValue));
  }
}
